import { useDebounceFn } from 'ahooks'
import { SearchBar } from 'antd-mobile'
import Icon from '@/components/Icon/Icon'
import styles from './index.module.less'

function KpSearch(props: any) {
  const { onChange, ...attrs } = props

  const { run: onSearchChange } = useDebounceFn(
    (value) => {
      onChange(value)
    },
    {
      wait: 30,
    },
  )

  return (
    <SearchBar { ...attrs }
      onChange={ onSearchChange }
      icon={
        <Icon name="search" size={ 32 } color="#A3A3A3" />
      }
      className={ styles['search-box'] } />
  )
}

export default KpSearch
